import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Grid, Header, Image, Message, Segment } from 'semantic-ui-react';
import logo from '../assets/svgs/funeral-live-logo.png';

import { resetUser } from '../actions/userActions';


const PasswordResetPage = (props) => {
  const [email, setEmail] = useState("");

  return (
  <Grid columns={1} textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
    <Grid.Row>
      <Grid.Column style={{ maxWidth: 600 }}>
        <Header as='h2' color='black' textAlign='center'>
          <Image src={logo} style={{ width: 150 }} /> We'll send a recovery link to
        </Header>
          {props.userReset.error && 
            <Message negative>
              <Message.Header>Something went wrong</Message.Header>
            </Message>
          }
          {props.userReset.success && 
            <Message positive>
              <Message.Header>Check your inbox for the recovery link</Message.Header>
            </Message>
          }
          <Segment stacked>
            <Input
              fluid
              icon='mail'
              iconPosition='left'
              placeholder='Email'
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              color='blue'
              fluid
              size='large'
              disabled={!email}
              onClick={() => props.resetUser(email)}>
                Send Recovery Link
            </Button>
          </Segment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
  );
}

const mapStateToProps = state => ({
  userReset: state.userReset
});

const mapDispatchToProps = {
  resetUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetPage);
